<script>
  import defaultFonts from "../../../stores/fileTemplateDefaultFonts"
  import Fontpreview from "./components/fontpreview.svelte"
  import TextArea from "./components/textArea.svelte"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import axios from "axios"
  import notify from "../../../../../../Script/notify"
  import { loadCSS } from "../../../../../../Script/loadLibrary"

  /**
   * @type {Boolean} Indicates whether the element is read-only or editable.
   */
  let readonly = true
  /**
   * @type {String} Represents a URL link.
   */
  let link = ""
  /**
   * @type {String} Represents a name of the font.
   */
  let fontName = ""
  /**
   * @type {Boolean} Indicates whether the text area should be shown/hidden.
   */
  let showTextArea = true
  /**
   * @type {Boolean} Indicates whether the Sent request button should be Enable/disable.
   */
  let disabledAddFont = false

  let closeNotification = {
    close() {},
  }
  /**
   * Generates a preview of the font style.
   */
  const fontStylePreview = async () => {
    /**
     * Checks if a font name is available.
     */
    if (fontName) {
      try {
        closeNotification.close()
        // console.log(fontName)
        disabledAddFont = true
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        /**
         * Sends a POST request to add the font to the server.
         */

        if ($defaultFonts.fontList.includes(fontName)) {
          showTextArea = true
          link = ""
          fontName = ""
          throw `${fontName} Font already exists`
        }

        const { data } = await axios.post(
          "/api/swagger/v2/fonts",
          {
            name: fontName,
            uri: link,
          },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        //error checking while api call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        // Adds the font name to the list of default fonts.
        $defaultFonts.fontList = [...$defaultFonts.fontList, data.font.name]
        closeNotification = notify.success(`${fontName} added Successfully`)

        $defaultFonts.fontList.sort()
        $defaultFonts.fontList = [...new Set($defaultFonts.fontList)]
        $defaultFonts.addCustomFont = false
      } catch (error) {
        const info = "PAGE: File template editor (Custom Font)\nEVENT: While adding new custom font"
        closeNotification = notify.danger(error, info)
      } finally {
        disabledAddFont = false
      }
    }
  }

  $: checkLink(link)
  const checkLink = (link) => {
    /**
     * Checks if the 'showTextArea' flag is true and the 'link' is false.
     * If the conditions are met, sets 'disabledAddFont' to true.
     */
    if (showTextArea) {
      if (!link) {
        disabledAddFont = true
      }
    }
  }
  /**
   * Handles the paste event.
   * @param {Event} e - The paste event object.
   */
  const onPasteEvent = (e) => {
    // Adds a small delay to ensure the pasted text is processed after it has been inserted.
    setTimeout(async () => {
      try {
        let pastedText = e.target.value // Get the value of the pasted text.

        pastedText = pastedText.replaceAll("'", '"') // Replaces single quotes with double quotes.

        // const regex = /<link\s+href="([^"]+)"\s+rel="stylesheet">/ // Regular expression to match the font link
        const regex = /<link\s+href="([^"]+)"(?:\s+rel="stylesheet")?|(?:\s+rel="stylesheet")?\s+href="([^"]+)">/

        const match = pastedText.match(regex) // Check if the pasted text matches the font link pattern.

        if (match) {
          link = match[1] || match[2] // Extract the font link from the match.
          // console.log(link, "link")
        } else {
          throw "Invalid Font URL" // Throw an error if the font link is invalid.
        }

        // const { data } = await axios.get(link) // Send a GET request to retrieve the font data.

        const pattern = /family=([^&"]+)/ // Regular expression to extract the font family from the link.
        const matches = link.match(pattern) // Check if the font family matches the pattern.

        if (matches) {
          fontName = decodeURIComponent(matches[1]).split(":")[0] // Extract the font family and remove any additional parameters.
          fontName = fontName.replaceAll("+", " ")
          // console.log(fontName)
          disabledAddFont = false // Enable the option to add the font.
        } else {
          throw "Invalid Font URL" // Throw an error if the font link is invalid.
        }
      } catch (error) {
        closeNotification.close()
        // console.error(error)
        setTimeout(() => {
          link = "" // Reset the font link.
          fontName = "" // Reset the font name.
        }, 300)
        disabledAddFont = true // Disable the option to add the font.
        const info = "PAGE: File template editor (Custom Font)\nEVENT: While validating font URL on paste"
        closeNotification = notify.danger("Invalid Font Url", info) // Show an error notification for the invalid font URL.
      }
    }, 10)
  }
</script>

<div class="fixed inset-0 z-40 flex flex-col items-center justify-center overflow-y-auto bg-[#000000cc] text-left backdrop-blur-md transition-opacity">
  {#if showTextArea}
    <div class="w-[400px]">
      <div class="w-full rounded-t-md bg-darkgray p-6">
        <div class="pb-3 text-lg font-bold tracking-wide text-slate-100">Custom Font</div>
        <p class="pb-3 text-sm font-normal leading-relaxed text-gray-600">If you have any custom font URL, Paste that custom font link here. Otherwise Import any custom font link and paste it here.</p>
        <TextArea
          on:paste={(e) => {
            onPasteEvent(e)
          }}
          bind:readonly
          bind:link
          {disabledAddFont}
        />
        <h1 class="py-2 text-base font-semibold tracking-wide text-slate-100">Font Name</h1>
        <input readonly value={fontName} type="text" class="w-full rounded-md border border-[#a0a1a580] bg-transparent py-2 pl-5 text-justify text-sm text-white outline-none placeholder:text-gray-200 focus:border focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
      </div>
    </div>
  {:else}
    <div class="w-[400px]">
      <div class="w-full rounded-t-md bg-darkgray p-6">
        <Fontpreview {fontName} />
      </div>
    </div>
  {/if}
  <div class="flex w-[400px] justify-between gap-3 rounded-b-md bg-[#242424] px-5 py-3">
    <button
      on:click={() => {
        $defaultFonts.addCustomFont = false
      }}
      class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none"
    >
      <span class="text-white">
        <i class="fa-solid fa-circle-xmark" />
      </span>
      <span class="select-none">&nbsp;&nbsp;Close</span>
    </button>
    <button
      on:click={() => {
        showTextArea = true
      }}
      class:hidden={showTextArea}
      class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 focus:outline-none"
    >
      <span class="text-white">
        <i class="fa-solid fa-backward" />
      </span>
      <span class="select-none">&nbsp;&nbsp;Previous</span>
    </button>
    {#if showTextArea}
      <button
        disabled={disabledAddFont}
        on:click={async () => {
          // console.log("clicked")

          await loadCSS(fontName, link)
          // console.log("after load CSS")
          showTextArea = false
          // console.log("after load CSS", showTextArea)
        }}
        class="active:bg-green-g00 {fontName ? 'cursor-pointer' : 'cursor-not-allowed'} group flex h-9 w-2/5 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30"
      >
        <span class="text-white">
          <i class="fa-solid fa-eye" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Preview</span>
      </button>
    {:else}
      <button disabled={disabledAddFont} on:click={fontStylePreview} class="active:bg-green-g00 {fontName ? 'cursor-pointer' : 'cursor-not-allowed'} group flex h-9 w-2/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30">
        <span class="text-white">
          <i class="fa-solid fa-plus" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Add new font</span>
      </button>
    {/if}
  </div>
</div>
